import { canIUseUnionPaySDK, canIUseTiktokSDK } from './utils';

/**
 * 云闪付小程序 SDK
 */
export const getUnionPaySDK = () => {
  if (canIUseUnionPaySDK && upsdk) {
    return upsdk;
  }
  return undefined;
};

/**
 * 抖音小程序 SDK
 */
export const getTiktokSDK = () => {
  if (canIUseTiktokSDK && tt) {
    return tt;
  }
  return undefined;
};
